import axios from 'axios';
import { Location, Event, Feature, SearchResponse } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const locationAPI = {
  search: async (query: string): Promise<Location[]> => {
    const response = await api.get('/locations/search', { params: { q: query } });
    return response.data;
  },
  
  getById: async (uniqueId: string): Promise<Location> => {
    const response = await api.get(`/locations/${uniqueId}`);
    return response.data;
  },

  getByUniqueId: async (uniqueId: string): Promise<Location> => {
    const response = await api.get(`/locations/unique/${uniqueId}`);
    return response.data;
  },
  
  getFeatured: async (): Promise<Location[]> => {
    const response = await api.get('/locations/featured');
    return response.data;
  },
};

export const eventAPI = {
  getByLocation: async (locationId: string): Promise<Event[]> => {
    const response = await api.get(`/events/location/${locationId}`);
    return response.data;
  },
  
  getByUniqueId: async (uniqueId: string): Promise<Event> => {
    const response = await api.get(`/events/unique/${uniqueId}`);
    return response.data;
  },

  incrementClick: async (uniqueId: string): Promise<Event> => {
    const response = await api.patch(`/events/${uniqueId}/click`);
    return response.data;
  },
};

export const featureAPI = {
  getHomeFeatures: async (): Promise<Feature[]> => {
    const response = await api.get('/features/home');
    return response.data;
  },
  
  getByLocation: async (locationId: string): Promise<Feature[]> => {
    const response = await api.get(`/features/location/${locationId}`);
    return response.data;
  },
};

export const searchAPI = {
  search: async (location: string): Promise<SearchResponse> => {
    const response = await api.get('/search', { params: { location } });
    return response.data;
  },
};